export const getClaimKeys = (claimText: string) => ({
  summaryKey: `${claimText}_summary`,
  rephraseKey: `${claimText}_rephrase`,
});
